import LateLoansLookup from '../data-deletion/LateLoansLookup';

/** Eliminar préstamos: por ahora solo consulta los préstamos con atraso de las rutas elegidas. */
const LoanDeletion = () => <LateLoansLookup titleKey="dataDeletion.titleLoans" />;

export default LoanDeletion;
